import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-100/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap"
          aria-label="天狼影院首页"
        >
          <div className="w-9 h-9 flex items-center justify-center">
            <i className="ri-movie-2-fill text-2xl text-primary-500"></i>
          </div>
          <span className="font-heading text-xl font-bold text-foreground-950">
            天狼影院
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              location.pathname === '/'
                ? 'bg-primary-500 text-background-50'
                : 'text-foreground-800 hover:text-foreground-950 hover:bg-background-200'
            }`}
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname.includes(`/category/${cat.slug}`)
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-800 hover:text-foreground-950 hover:bg-background-200'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              location.pathname === '/about'
                ? 'bg-primary-500 text-background-50'
                : 'text-foreground-800 hover:text-foreground-950 hover:bg-background-200'
            }`}
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <div className="relative">
            <input
              type="text"
              placeholder="搜索影片..."
              className="w-48 pl-9 pr-4 py-2 rounded-full bg-background-200 border border-background-300 text-sm text-foreground-800 placeholder-foreground-500 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-all duration-200"
            />
            <div className="w-5 h-5 flex items-center justify-center absolute left-3 top-1/2 -translate-y-1/2">
              <i className="ri-search-line text-foreground-500 text-sm"></i>
            </div>
          </div>
          <button className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 cursor-pointer">
            <i className="ri-user-3-line"></i>
          </button>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-800 hover:bg-background-200 transition-colors cursor-pointer"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="打开菜单"
        >
          <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-t border-background-200 animate-fade-in">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap ${
                location.pathname === '/'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-800'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-800'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-800'
              }`}
            >
              关于我们
            </Link>
            <div className="pt-2">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索影片..."
                  className="w-full pl-9 pr-4 py-2.5 rounded-full bg-background-200 border border-background-300 text-sm text-foreground-800 placeholder-foreground-500 focus:outline-none focus:border-primary-400"
                />
                <div className="w-5 h-5 flex items-center justify-center absolute left-3 top-1/2 -translate-y-1/2">
                  <i className="ri-search-line text-foreground-500 text-sm"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}